import axios from 'axios'
import {decode} from 'jsog'

const toData = response => decode(response.data)

export function getQuestion(questionId, scanId): Promise {
  return !!scanId ?  // existing scan?
    axios.get(`/bw/question/${questionId}/scan/${scanId}`).then(toData) :
    axios.get(`/bw/question/${questionId}/`).then(toData);
}



// WEBPACK FOOTER //
// ./src/services/question-service.js